<style>
  .UnValue{
    color: #f91010;
    font-weight: bolder;
    font-style: italic;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="deviceBehfa_id_Innner==0">Edit Behfa Equipment</h5>
      <h5 class="card-title" *ngIf="deviceBehfa_id_Innner>0">Behfa Equipment Information</h5>
      <form [formGroup]="EditNewDeviceBehfa" (submit)="SubmitAddNewDevice()">

        <input type="hidden" formControlName="id" />

        <h5>General Information</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Group</label>
            <select class="custom-select" formControlName="GroupId"  (change)="GroupChange()">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_DeviceGroup_Parent" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Sub Group</label>
            <select class="custom-select" formControlName="SubGroupId" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_DeviceGroup_Child2" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Count</label>
            <input formControlName="count" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_count().valid && get_Form_count().touched" class="form-text text-muted MyErrorRedColor">Enter the count.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">type</label>
            <input formControlName="type" type="text" style="font-family: Arial, Helvetica, sans-serif;" class="form-control EnglishClm"  placeholder="Type here...">
            <small *ngIf="!get_Form_type().valid && get_Form_type().touched" class="form-text text-muted MyErrorRedColor">Enter the type.</small>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_Description_Validation()}">Description</label>
            <input formControlName="Description" type="text" style="font-family: Arial, Helvetica, sans-serif;" class="form-control EnglishClm"  placeholder="Type here...">
            <small *ngIf="!get_Form_Description().valid && get_Form_Description().touched" class="form-text text-muted MyErrorRedColor">Enter the description.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Calibration Required</label>
            <select class="custom-select" (change)="NeedCalibration_Change()" formControlName="NeedCalibration" >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Cabinet</label>
            <select class="custom-select"  formControlName="Cabinet_id" >
              <option value="0">No Cabinet</option>
              <option *ngFor="let item of DataList_Cabinet" [value]="item.id">{{item.title}}  - {{item.dsc}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Equipment Classification</label>
            <select class="custom-select" formControlName="CategoryId">
              <option value="0">Select</option>
              <option value="1">Reference</option>
              <option value="2">Secondary</option>
              <option value="3">Working</option>
            </select>
          </div>
        </div>


        <br/>
        <hr/>
        <h5>Information Equipment</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_Manufacturer_Validation()}">Manufacturer</label>
            <input formControlName="Manufacturer" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="Type here...">
            <small *ngIf="!get_Form_Manufacturer().valid && get_Form_Manufacturer().touched" class="form-text text-muted MyErrorRedColor">Enter the manufacturer.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_Model_Validation()}">Model</label>
            <input formControlName="Model" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="Type here...">
            <small *ngIf="!get_Form_Model().valid && get_Form_Model().touched" class="form-text text-muted MyErrorRedColor">Enter the model.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_CodeBEHFA_Validation()}">Code BEHFA</label>
            <input formControlName="CodeBEHFA" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="Type here...">
            <small *ngIf="!get_Form_CodeBEHFA().valid && get_Form_CodeBEHFA().touched" class="form-text text-muted MyErrorRedColor">Enter the BEHFA code.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_Serial_Validation()}">Serial Number</label>
            <input formControlName="Serial" type="text"    class="form-control "  placeholder="Type here...">
            <small *ngIf="!get_Form_Serial().valid && get_Form_Serial().touched" class="form-text text-muted MyErrorRedColor">Enter the serial number.</small>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_Countery_Validation()}">Country of Manufacture</label>
            <input formControlName="Countery" type="text"   class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Countery().valid && get_Form_Countery().touched" class="form-text text-muted MyErrorRedColor">Enter the country of manufacture.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Seller - Contractor</label>
            <select class="custom-select" (change)="ReadData_Contractor_Seller()" formControlName="SellerContractor" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-4" >
            <label for="exampleInputEmail1">Seller - Customer</label>
            <select class="custom-select" formControlName="Seller" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Contractor_Seller" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Purchase Date</label>
            <input type="text" formControlName="dateBuy"  #datepickerBuy placeholder="Type here..."   class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Commissioning Date</label>
            <input type="text" formControlName="dateRun" #datepickerRun  placeholder="Type here..."  class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerRun"></ng-persian-datepicker>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Price</label>
            <input formControlName="Price" type="text"   class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Price().valid && get_Form_Price().touched" class="form-text text-muted MyErrorRedColor">Enter the price.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Currency</label>
            <select class="custom-select" formControlName="PriceVahed">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
            <div class="form-group col-md-2">
            <label for="exampleInputEmail1">
              Authorized Repairer - Contractor

            </label>
            <select class="custom-select" (change)="ReadData_Contractor_Fixer()" formControlName="FixerContractor" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
            </select>

          </div>
          <div class="form-group col-md-4" >
            <label for="exampleInputEmail1">
              Authorized Repairer - Customer
              <button (click)="OnAdd_RabetMasolCustomer_Fixer()"  type="button" [disabled]="get_Form_Fixer().value =='0'"  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <select class="custom-select" formControlName="Fixer" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Contractor_Fixer" [value]="item.id">{{item.title}}</option>
            </select>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="RabetMasolCustomer_Fixer.length>0">
              <tr class="bg-warning" *ngFor="let item of RabetMasolCustomer_Fixer">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="RabetMasolCustomer_Fixer_Delete(RabetMasolCustomer_Fixer.indexOf(item))"><i class="fa fa-remove"></i> Delete </a>
                  </td>
              </tr>
            </table>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">Initial Status</label>
            <select class="custom-select" formControlName="InitialStatus" >
              <option value="-1">Select</option>
              <option value="1">Used</option>
              <option value="0">New</option>
            </select>
          </div>

          <div class="form-group col-md-3" [hidden]="get_Form_NeedCalibration().value=='0'">
            <label for="exampleInputEmail1">Calibration Interval (Months)</label>
            <input formControlName="CalibrationPeriod" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_CalibrationPeriod().valid && get_Form_CalibrationPeriod().touched" class="form-text text-muted MyErrorRedColor">Enter the calibration interval (months).</small>
          </div>



          <div class="form-group col-md-3" [hidden]="get_Form_NeedCalibration().value=='0'">
            <label for="exampleInputEmail1">Warning Period Before Calibration Expiration (Days)</label>
            <select class="custom-select" formControlName="WarningTime" >
              <option value="0">Select</option>
              <option *ngFor="let item of DayList" [value]="item">{{item}} days</option>
            </select>
          </div>

        </div>


        <br/>
        <hr/>
        <h5>Working Range</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1" >Minimum</label>
            <input formControlName="GostarehMin" type="number"  class="form-control EnglishClm"  placeholder="Type here...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Maximum</label>
            <input formControlName="GostarehMax" type="number"  class="form-control EnglishClm"  placeholder="Type here...">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Increment</label>
            <input formControlName="Zineh" type="number"  class="form-control EnglishClm"  placeholder="Type here...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Unit</label>
            <select class="custom-select" formControlName="GostarehVahed" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.id">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Maximum Permissible Error</label>
            <input formControlName="HadMojaz" type="text"  class="form-control EnglishClm"  placeholder="Type here...">
          </div>


          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Unit</label>
            <select class="custom-select" formControlName="HadMojazVahed" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.id">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>

        </div>

        <button type="button" *ngIf="Edit_DataList_Gostareh_Indxer==-1" (click)="OnAdd_Gostareh()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add to Table </button>
        <button type="button" *ngIf="Edit_DataList_Gostareh_Indxer>-1" (click)="OnAdd_Gostareh()"  class="btn btn-warning" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Working Range </button>

        <div class="table-responsive" *ngIf="DataList_Gostareh.length>0 && Edit_DataList_Gostareh_Indxer==-1">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Minimum</th>
                <th>Maximum</th>
                <th>Increment</th>
                <th>Unit</th>
                <th>Maximum Permissible Error</th>
                <th>Unit</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_Gostareh">
                <td>{{DataList_Gostareh.indexOf(item)+1}}</td>
                <td>{{item.min}}</td>
                <td>{{item.max}}</td>
                <td>{{item.zineh}}</td>
                <td>
                  <div innerHTML="{{item.vahed_title}}"></div>
                </td>
                <td>{{item.error}}</td>
                <td>
                  <div innerHTML="{{item.error_vahed_title}}"></div>
                </td>
                <td>
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="Edit_DataList_Gostareh(DataList_Gostareh.indexOf(item))" class="dropdown-item" ><i class="fa fa-edit"></i> Edit </a>
                          <a style="cursor: pointer;" (click)="Delete_DataList_Gostareh(DataList_Gostareh.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                        </div>
                    </div>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br/>
        <hr/>

        <h5>Authorized Operator Information</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6" >
            <label for="exampleInputEmail1">Calibrated By</label>
            <select class="custom-select" formControlName="AfradMojaz">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_ExpertCalibration" [value]="item.id">{{item.name}} {{item.familly}}</option>
            </select>
          </div>
        </div>

        <button type="button" (click)="OnAdd_AfradMojaz()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add to Table </button>

        <div class="table-responsive" *ngIf="DataList_AfradMojaz.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Full Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_AfradMojaz">
                <td>{{DataList_AfradMojaz.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="Delete_DataList_AfradMojaz(DataList_AfradMojaz.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                        </div>
                    </div>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br/>
        <hr/>

        <h5>Technical Information</h5>
        <br/>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_TechnicalSpecifications_Validation()}">Technical Specifications</label>
            <textarea formControlName="TechnicalSpecifications" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_TechnicalSpecifications().valid && get_Form_TechnicalSpecifications().touched" class="form-text text-muted MyErrorRedColor">Enter the technical specifications.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_TechnicalDsc_Validation()}">Description</label>
            <textarea formControlName="TechnicalDsc" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_TechnicalDsc().valid && get_Form_TechnicalDsc().touched" class="form-text text-muted MyErrorRedColor">Enter the description.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1" [ngClass]="{'UnValue': get_Form_JobAlerts_Validation()}">Operating Warnings</label>
            <textarea formControlName="JobAlerts" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_JobAlerts().valid && get_Form_JobAlerts().touched" class="form-text text-muted MyErrorRedColor">Enter the operating warnings.</small>
          </div>
          <div class="form-group col-md-6"  [ngClass]="{'UnValue': get_Form_EnvironmentalConditions_Validation()}">
            <label for="exampleInputEmail1">Environmental Conditions</label>
            <textarea formControlName="EnvironmentalConditions" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_EnvironmentalConditions().valid && get_Form_EnvironmentalConditions().touched" class="form-text text-muted MyErrorRedColor">Enter the environmental conditions.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Storage Conditions</label>
            <textarea formControlName="ConditionKeep" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_ConditionKeep().valid && get_Form_ConditionKeep().touched" class="form-text text-muted MyErrorRedColor">Enter the operating warnings.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Transportation Conditions</label>
            <textarea formControlName="ConditionTransport" type="text"   class="form-control"  placeholder="Type here..."></textarea>
            <small *ngIf="!get_Form_ConditionTransport().valid && get_Form_ConditionTransport().touched" class="form-text text-muted MyErrorRedColor">Enter the environmental conditions.</small>
          </div>
        </div>



        <div [hidden]="get_Form_NeedCalibration().value=='0'">
          <br/>
          <hr/>
          <h5>Information Calibration</h5>
          <br/>

          <div class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Calibrating Company - Contractor</label>
              <select class="custom-select" (change)="ReadData_Contracto_CalibratingCustomer()" formControlName="CalibratingCompany" >
                <option value="0">Select</option>
                <option value="-1">Behfa</option>
                <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

            <div class="form-group col-md-3" [hidden]="get_Form_CalibratingCompany().value=='-1'" >
              <label for="exampleInputEmail1">Calibrating Company - Customer</label>
              <select class="custom-select" formControlName="CalibratingCustomer" >
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_Contractor_CalibratingCustomer" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

            <div class="form-group col-md-6" [hidden]="get_Form_CalibratingCompany().value!='-1'">
              <label for="exampleInputEmail1">Calibrated By</label>
              <select class="custom-select" formControlName="CalibratingName">
                <option value="0">---</option>
                <option *ngFor="let item of DataList_ExpertCalibration" [value]="item.id">{{item.name}} {{item.familly}}</option>
              </select>
            </div>

            <div class="form-group col-md-3" [hidden]="get_Form_CalibratingCompany().value=='-1'">
              <label for="exampleInputEmail1">Calibrated By</label>
              <input formControlName="CalibratingNameType" type="text"  class="form-control " placeholder="Type here...">
            </div>


          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Certificate No</label>
              <input formControlName="CertificateNo" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="Type here...">
              <small *ngIf="!get_Form_CertificateNo().valid && get_Form_CertificateNo().touched" class="form-text text-muted MyErrorRedColor">Enter the certificate number.</small>
            </div>
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Measurement Uncertainty</label>
              <input formControlName="Uncertainty" type="text"  style="font-family: Arial, Helvetica, sans-serif;"  class="form-control EnglishClm"  placeholder="Type here...">
              <small *ngIf="!get_Form_Uncertainty().valid && get_Form_Uncertainty().touched" class="form-text text-muted MyErrorRedColor">Enter the measurement uncertainty.</small>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Type Date Cal. Due</label>
              <select class="custom-select" formControlName="CalDueType" >
                <option value="0">Jalali Date</option>
                <option value="1">Gregorian Date</option>
              </select>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDueType().value=='0'">
              <label for="exampleInputEmail1">Cal. Due</label>
              <input formControlName="CalDueMiladi" type="date"  style="font-family: Arial, Helvetica, sans-serif;"  data-date-format="DD MMMM YYYY" class="form-control"  placeholder="Type here...">
              <small *ngIf="!get_Form_CalDueMiladi().valid && get_Form_CalDueMiladi().touched" class="form-text text-muted MyErrorRedColor">Enter the calibration due date.</small>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDueType().value=='1'">
              <label for="exampleInputEmail1">Cal. Due</label>
              <input type="text" formControlName="CalDueShamsi" #datepickerCalDueShamsi placeholder="Type here..."   class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerCalDueShamsi"></ng-persian-datepicker>
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1">Type Date Cal. DATE</label>
              <select class="custom-select" formControlName="CalDATEType" >
                <option value="0">Jalali Date</option>
                <option value="1">Gregorian Date</option>
              </select>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDATEType().value=='0'">
              <label for="exampleInputEmail1">Cal. DATE</label>
              <input formControlName="CalDATEMiladi" type="date"  style="font-family: Arial, Helvetica, sans-serif;"  data-date-format="DD MMMM YYYY" class="form-control"  placeholder="Type here...">
              <small *ngIf="!get_Form_CalDATEMiladi().valid && get_Form_CalDATEMiladi().touched" class="form-text text-muted MyErrorRedColor">Enter the calibration date.</small>
            </div>
            <div class="form-group col-md-3" [hidden]="get_Form_CalDATEType().value=='1'">
              <label for="exampleInputEmail1">Cal. DATE</label>
              <input formControlName="CalDATEShamsi" type="text" #datepickerCalDATEShamsi placeholder="Type here..."   class="form-control" />
              <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerCalDATEShamsi"></ng-persian-datepicker>
            </div>


          </div>

          <div class="row">

            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Price</label>
              <input formControlName="CalibratingPrice" type="number"   class="form-control"  placeholder="Type here...">
              <small *ngIf="!get_Form_CalibratingPrice().valid && get_Form_CalibratingPrice().touched" class="form-text text-muted MyErrorRedColor">Enter the price.</small>
            </div>
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">Currency</label>
              <select class="custom-select" formControlName="CalibratingPriceVahed">
                <option value="0">Select</option>
                <option *ngFor="let item of DataList_Money" [value]="item.id">{{item.title}}</option>
              </select>
            </div>

          </div>

          <br/>
          <hr/>
          <br/>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="exampleInputEmail1">
                 Attachments
                <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
              </label>
              <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
              <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="Type here...">
            </div>
          </div>

          <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

          <br/>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>File</th>
                  <th>Date</th>
                  <th>User</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td *ngIf="!item.domain">
                      <a target="_blank" *ngIf="item.title.includes('.pdf')"  href="{{BaseUrl}}File/DeviceBehfa/{{item.title}}" class="btn btn-success" ><i class="fa fa-file-pdf-o"></i> PDF </a>
                    </td>
                    <td *ngIf="item.domain">
                      <button (click)="openModal_File_Ref(template,item)" type="button" class="btn btn-danger" > View Request  </button>
                    </td>
                    <td>{{item.persianDate}}</td>
                    <td>{{item.username}} </td>
                    <td>
                        <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Actions
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>

          <br/>

        </div>



        <img *ngIf="InProccessing && deviceBehfa_id_Innner==0" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && (deviceBehfa_id_Innner==0 || can_Submit_Innner)" type="submit"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing && deviceBehfa_id_Innner==0" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/DeviceBehfa" *ngIf="!InProccessing && deviceBehfa_id_Innner==0" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
        <button (click)="OnSet_Back_DeviceBehfa_From_Edit()" *ngIf="!InProccessing && deviceBehfa_id_Innner>0" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Submit Reference Certificate View Request
      {{Selected_File_Ref.title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_File_Ref.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="OperationDsc_File_Ref" name="OperationDsc_File_Ref" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="Submit_File_Ref()"> Submit for Review <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_File_Ref.hide()">Close</button>
  </div>
</ng-template>
